// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__DvnmM","privacy-container":"Privacy_privacy-container__mwUdB","lists":"Privacy_lists__uRlrK"};